<template>
  <transition name="commentary-animatiion">
    <edi-muted-comment-list-item
      v-if="isUserMuted(userId)"
      :user-nick="userNick"
      :user-id="userId"
      :user-profile-url="userProfileUrl"
      :num="num"
    />
  <edi-moderated-comment-list-item
    v-if="isModeratedComment"
    :comment="comment"
    :content-id="contentId"
  />
    <li class="comment" :class="type" v-else>
      <div class="comment-wrapper">
        <div class="comment-header">
          <edi-user-comment-avatar
            :user-profile-url="userProfileUrl"
            :src="userAvatarUrl" />
          <div class="comment-header-wrapper">
            <edi-user-comment
              :num="num"
              :user-nick="userNick"
              :publication-date="publicationDate"
              :user-profile-url="userProfileUrl" />
            <edi-replied-comment-chip v-if="commentIsReply" :comment="repliedComment" />
            <edi-featured-comment-chip v-if="isFeatured" />
          </div>
        </div>
        <div class="comment-text">
          <p class="text">{{ text }}</p>
        </div>
        <edi-comment-actions
          :likes="totalLikes"
          :dislikes="totalDislikes"
          :moderated-votes="moderatedVotes"
          :comment-id="id"
          :content-id="contentId"
          :user-id="userId"
          :user-nick="userNick"
          :is-author="isAuthorComment"
          :comment-type="commentType"
        />
      </div>
    </li>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { PARTNER_COMMENT, DEFAULT_COMMENT, AUTHOR_COMMENT } from '../../api';

import EdiCommentActions from '../EdiCommentActions';
import EdiUserCommentAvatar from '../user/EdiUserCommentAvatar';
import EdiUserComment from '../user/EdiUserComment';
import EdiFeaturedCommentChip from '../featured/EdiFeaturedCommentChip';
import EdiCommentValuationBtn from '../btn/EdiCommentValuationBtn';
import EdiCommentBadger from '../badger/EdiCommentBadger';
import EdiMutedCommentListItem from './EdiMutedCommentListItem';
import EdiModeratedCommentListItem from './EdiModeratedCommentListItem';
import EdiRepliedCommentChip from '../reply/EdiRepliedCommentChip';

export default {
  name: 'edi-comment-list-item',
  components: {
    EdiUserCommentAvatar,
    EdiUserComment,
    EdiFeaturedCommentChip,
    EdiCommentActions,
    EdiCommentValuationBtn,
    EdiCommentBadger,
    EdiMutedCommentListItem,
    EdiModeratedCommentListItem,
    EdiRepliedCommentChip,
  },
  props: {
    comment: Object,
    contentId: Number,
    commentType: Number,
  },
  computed: {
    ...mapGetters([
      'isUserMuted',
    ]),
    id() {
      return this.comment?.id;
    },
    num() {
      return this.comment?.threadRelativeCommentId;
    },
    text() {
      return this.comment?.text;
    },
    valuation() {
      return {};
    },
    userNick() {
      return this.comment?.userName;
    },
    userAvatarUrl() {
      const userAvatarUrl = this.comment?.user.avatarUrl;
      return userAvatarUrl || '/assets/img/default-user-avatar.png';
    },
    partnerAge() {
      return this.comment?.user?.partnerAge;
    },
    courtesy() {
      return this.comment?.user?.courtesy;
    },
    moderatedVotes() {
      return this.comment?.numReports;
    },
    isFeatured() {
      return this.comment?.isFeatured;
    },
    publicationDate() {
      // Esta patata la hacemos porque en el showroom el Datetime es serializado
      // a un objeto de js con estas propiedades, sin embargo cuando la respuesta
      // viene del Api dicha propiedad viene serializa como un string directamente
      const publicationDate = this.comment?.publicationDate?.date;
      return publicationDate || this.comment?.publicationDate;
    },
    replies() {
      return this.comment?.replies;
    },
    type() {
      if (this.isAuthorComment) {
        return AUTHOR_COMMENT;
      }
      if (this.isPartnerComment
            && this.courtesy !== '') {
        return PARTNER_COMMENT;
      }
      return DEFAULT_COMMENT;
    },
    isPartnerComment() {
      return this.comment?.user?.isPartner;
    },
    isAuthorComment() {
      return this.comment?.user?.isAuthor;
    },
    isModeratedComment() {
      return this.comment?.isModerated;
    },
    totalLikes() {
      return this.comment?.numVotesPositive;
    },
    totalDislikes() {
      return this.comment?.numVotesNegative;
    },
    commentIsReply() {
      return !!this.comment?.repliedComment;
    },
    repliedComment() {
      return this.comment?.repliedComment;
    },
    userId() {
      return this.comment?.user?.userId;
    },
    userProfileUrl() {
      return this.comment?.user?.profileUrl;
    },
  },
};
</script>

<style scoped>
  .commentary-animatiion-enter-active {
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .commentary-animatiion-enter {
    opacity: 0;
  }

</style>
